<template>
  <div class="flex flex-col items-center mt-20">
    <h4>This is the Organizations Page</h4>
    <h6>Organization ID: {{ orgId }}</h6>
  </div>
</template>

<script>
export default {
  name: 'Organizations',
  computed: {
    orgId() {
      return this.$route.params.orgId
    }
  }
}
</script>
